<template>
  <v-menu offset-y :close-on-content-click="false" v-model="menuModel">
    <template v-slot:activator="{ props }">
      <v-btn block :color="colors.ACCENT" v-bind="props">
        Clients
        <v-icon :icon="menuModel ? 'mdi-chevron-up' : 'mdi-chevron-down'" class="ml-2"></v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item>
        <v-text-field
          :model-value="searchQuery"
          @input="$emit('update:search-query', ($event.target as HTMLInputElement).value)"
          label="Search clients"
          prepend-inner-icon="mdi-magnify"
          single-line
          hide-details
        ></v-text-field>
      </v-list-item>
      <v-list-item
        v-for="(item, index) in filteredClients"
        :key="index"
        @click="$emit('select-client', item)"
      >
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type Client from '@/models/client';

const props = defineProps<{
  menu: boolean;
  clients: Client[];
  filteredClients: Client[];
  searchQuery: string;
}>();

const emit = defineEmits<{
  'update:menu': [value: boolean];
  'update:search-query': [value: string];
  'select-client': [client: Client];
}>();

const menuModel = computed({
  get: () => props.menu,
  set: (value) => emit('update:menu', value)
});

const colors = {
  ACCENT: '#F29B00'
};
</script> 